import * as React from 'react';

interface SocialSvgProps {
  className?: string;
}

export const LinkedIn: React.FC<SocialSvgProps> = ({ className }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-platform="linkedin"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.038-1.852-3.038-1.853 0-2.136 1.446-2.136 2.94v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.852 3.37-1.852 3.601 0 4.267 2.37 4.267 5.455v6.288zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.063 2.062 2.062 0 1 1 2.063 2.063zM7.119 20.452H3.554V9h3.565v11.452zM22.225 0H1.771C.792 0 0 .771 0 1.723v20.549C0 23.229.792 24 1.771 24h20.451C23.205 24 24 23.229 24 22.272V1.723C24 .771 23.205 0 22.225 0z" />
  </svg>
);
